import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-header',
  templateUrl: './application-header.component.html',
  styleUrls: ['./application-header.component.scss']
})

export class ApplicationHeaderComponent {
}
